// Packages
import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Helpers
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

// Components
import GroupContent from './group-content';

// Redux
import * as channelsActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/channel-profile';

// Instantiate an instance of dragula for drag & drop
import dragula from 'react-dragula';
const drake = dragula({
    direction: 'horizontal'
});

export class Groups extends React.Component {
    constructor(props) {
        super(props);

        // If drop event listener exists, remove it
        drake.off('drop');
        // Add on drop event listener
        drake.on('drop', this.dragulaElementWasDropped.bind(this));
    }

    logMixPanelForContentCount(contentCount) {
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.gotContent}`, {contentCount});
    }

    dragulaElementWasDropped(el, target, source, sibling) {
        const contentToMove = el.querySelector('.catalog-card-container').id.split('catalog-card-container-id-')[1];
        // Sibling content is the element to the right of the content that is being drag & dropped.
        // If a content is being moved to the end (very right) then it will not have a sibling
        const siblingContent = sibling ? sibling.querySelector('.catalog-card-container').id.split('catalog-card-container-id-')[1] : null;
        const srcGroupKey = source.id;
        const destGroupKey = target.id;
        // if you are moving a content within the same group then source container will equal target container
        if (source === target) {
            this.props.moveContentWithinGroup(this.props.channelKey, srcGroupKey, destGroupKey, contentToMove, siblingContent);
        } else {
            drake.cancel(true);
            this.props.moveContentToAnotherGroup(this.props.channelKey, srcGroupKey, destGroupKey, contentToMove, siblingContent);
        }
    }

    renderGroupContent() {
        let contentCount = 0;
        const groupDataList = this.props.groupData;
        const displayGroups = [];
        if (groupDataList) {
            for (const groupData of groupDataList) {
                displayGroups.push(<GroupContent
                  key={groupData.groupKey}
                  t={this.props.t}
                  isChannelOwner={this.props.isChannelOwner}
                  channelKey={this.props.channelKey}
                  groupData={groupData}
                  deleteGroup={this.props.deleteGroup}
                  displayContent={this.props.displayContent}
                  editRecordingTitle={this.props.editRecordingTitle}
                  deleteThumbnail={this.props.deleteThumbnail}
                  featuredClicked={this.props.featuredClicked}
                  isFeatured={this.props.isFeatured}
                  thumbnailUploadClicked={this.props.thumbnailUploadClicked}
                  categoryChangeClicked={this.props.categoryChangeClicked}
                  numberOfGroups={this.props.numberOfGroups}
                  mountInternalErrorPage={this.props.mountInternalErrorPage}
                  dragulaInstance={drake}
                />);
                if (groupData.contentKeys) {
                    contentCount += groupData.contentKeys.length;
                }
            }
        }
        this.logMixPanelForContentCount(contentCount);
        return displayGroups;
    }

    render() {
        return (<div> {this.renderGroupContent()} </div>);
    }
}

Groups.propTypes = {
    t: PropTypes.func.isRequired,
    isChannelOwner: PropTypes.bool.isRequired,
    groupData: PropTypes.array.isRequired,
    channelKey: PropTypes.string.isRequired,
    deleteGroup: PropTypes.func.isRequired,
    displayContent: PropTypes.func.isRequired,
    editRecordingTitle: PropTypes.func.isRequired,
    deleteThumbnail: PropTypes.func.isRequired,
    featuredClicked: PropTypes.func.isRequired,
    isFeatured: PropTypes.func.isRequired,
    thumbnailUploadClicked: PropTypes.func.isRequired,
    categoryChangeClicked: PropTypes.func.isRequired,
    numberOfGroups: PropTypes.number.isRequired,
    moveContentToAnotherGroup: PropTypes.func.isRequired,
    moveContentWithinGroup: PropTypes.func.isRequired,
    mountInternalErrorPage: PropTypes.func.isRequired
};

export default connect(
    state => ({
        channel: state.channel.channel
    }),
    dispatch => bindActionCreators({...channelsActions}, dispatch)
)(translate(['translation'])(Groups));



// WEBPACK FOOTER //
// ./src/components/catalog/group/groups.js